export default __webpack_public_path__ + "static/media/logo_header_pc.222efe5d.png";